import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { Flex } from '@repo/ui/Flex';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogFooter.module.css';

export type DialogFooterProps = ComponentPropsWithoutRef<'footer'> & {
  className?: string;
};

export const dialogFooterVariants = cva(s.footer, {
  variants: {
    variant: {
      compact: s.compactVariant,
      standard: s.standardVariant,
    },
  },
});

export const DialogFooter = (props: DialogFooterProps) => {
  const { children, className, ...attrs } = props;
  const { variant } = useDialog();

  return (
    <Flex
      as="footer"
      alignItems="center"
      justifyContent={variant === 'compact' ? 'flex-end' : 'center'}
      shrink="0"
      className={clsx(dialogFooterVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </Flex>
  );
};
